import APIKit from "../Allapis/Apikit/apikit";

export const getCardRequests = async () => {
  let results;
  try {
    const url = "cards/requests";
    results = await APIKit.get(url);
    return results.data;
  } catch (e) {
    return e.response ? e.response.data : e;
  }
};

export const dispatchCard = async (body) => {
  let results;
  try {
    const url = "cards/dispacthCard";
    results = await APIKit.post(url, body);
    return results.data;
  } catch (e) {
    return e.response ? e.response.data : e;
  }
};
